// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-area {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.5rem 2rem;
  background-color: #F8FAFC;
  border-top: 1px solid #E2E8F0;
}

.input-container {
  display: flex;
  gap: 0.75rem;
  align-items: flex-end;
}

.message-input {
  flex: 1;
  font-size: 1rem;
  padding: 0.75rem 1rem;
  border: 2px solid #D5DBDB;
  border-radius: 8px;
  font-family: inherit;
  resize: none;
  min-height: 44px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.message-input:focus {
  outline: none;
  border-color: #0EA5E9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);
}

.message-input:disabled {
  background-color: #F0F0F0;
  color: #999;
  cursor: not-allowed;
  border-color: #E5E5E5;
}

.send-button {
  min-width: 44px;
  height: 44px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0EA5E9;
  transition: background-color 0.2s ease, transform 0.1s ease;
}

.send-button:hover:not(:disabled) {
  background-color: #0284C7;
  transform: scale(1.05);
}

.send-button:active:not(:disabled) {
  transform: scale(0.98);
}

.send-button:disabled {
  background-color: #D5DBDB;
  cursor: not-allowed;
}

.input-footer {
  font-size: 0.875rem;
  color: #666;
  margin-top: 0.25rem;
  text-align: center;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #0EA5E9;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .input-area {
    padding: 1rem 1.5rem;
    gap: 0.5rem;
  }
  
  .message-input {
    font-size: 0.95rem;
    padding: 0.65rem 0.85rem;
    min-height: 42px;
  }
  
  .send-button {
    min-width: 42px;
    height: 42px;
  }
  
  .input-footer {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .input-area {
    padding: 0.75rem 1rem;
  }
  
  .message-input {
    font-size: 0.9rem;
    padding: 0.6rem 0.75rem;
    min-height: 40px;
    border-radius: 6px;
  }
  
  .send-button {
    min-width: 40px;
    height: 40px;
  }
  
  .input-footer {
    font-size: 0.75rem;
  }
}


/* Bottom-left "Report a bug or issue" control (spec ordis-bug-report). A
   small circular button that sits to the left of the message input and
   opens the bug-report modal. Visually secondary to the send button. */
.bug-report-button {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid #D5DBDB;
  border-radius: 50%;
  background-color: #FFFFFF;
  color: #687078;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.1s ease;
}

.bug-report-button:hover {
  background-color: #F1F5F9;
  border-color: #94A3B8;
  color: #0F172A;
  transform: scale(1.05);
}

.bug-report-button:focus-visible {
  outline: none;
  border-color: #0EA5E9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);
}

.bug-report-button:active {
  transform: scale(0.98);
}
`, "",{"version":3,"sources":["webpack://./src/components/InputBar/InputBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,0BAA0B;AAC1B;EACE;IACE,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;;AAGA;;uEAEuE;AACvE;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oGAAoG;AACtG;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".input-area {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 1.5rem 2rem;\n  background-color: #F8FAFC;\n  border-top: 1px solid #E2E8F0;\n}\n\n.input-container {\n  display: flex;\n  gap: 0.75rem;\n  align-items: flex-end;\n}\n\n.message-input {\n  flex: 1;\n  font-size: 1rem;\n  padding: 0.75rem 1rem;\n  border: 2px solid #D5DBDB;\n  border-radius: 8px;\n  font-family: inherit;\n  resize: none;\n  min-height: 44px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.message-input:focus {\n  outline: none;\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);\n}\n\n.message-input:disabled {\n  background-color: #F0F0F0;\n  color: #999;\n  cursor: not-allowed;\n  border-color: #E5E5E5;\n}\n\n.send-button {\n  min-width: 44px;\n  height: 44px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #0EA5E9;\n  transition: background-color 0.2s ease, transform 0.1s ease;\n}\n\n.send-button:hover:not(:disabled) {\n  background-color: #0284C7;\n  transform: scale(1.05);\n}\n\n.send-button:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.send-button:disabled {\n  background-color: #D5DBDB;\n  cursor: not-allowed;\n}\n\n.input-footer {\n  font-size: 0.875rem;\n  color: #666;\n  margin-top: 0.25rem;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #0EA5E9;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .input-area {\n    padding: 1rem 1.5rem;\n    gap: 0.5rem;\n  }\n  \n  .message-input {\n    font-size: 0.95rem;\n    padding: 0.65rem 0.85rem;\n    min-height: 42px;\n  }\n  \n  .send-button {\n    min-width: 42px;\n    height: 42px;\n  }\n  \n  .input-footer {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .input-area {\n    padding: 0.75rem 1rem;\n  }\n  \n  .message-input {\n    font-size: 0.9rem;\n    padding: 0.6rem 0.75rem;\n    min-height: 40px;\n    border-radius: 6px;\n  }\n  \n  .send-button {\n    min-width: 40px;\n    height: 40px;\n  }\n  \n  .input-footer {\n    font-size: 0.75rem;\n  }\n}\n\n\n/* Bottom-left \"Report a bug or issue\" control (spec ordis-bug-report). A\n   small circular button that sits to the left of the message input and\n   opens the bug-report modal. Visually secondary to the send button. */\n.bug-report-button {\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 1px solid #D5DBDB;\n  border-radius: 50%;\n  background-color: #FFFFFF;\n  color: #687078;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.1s ease;\n}\n\n.bug-report-button:hover {\n  background-color: #F1F5F9;\n  border-color: #94A3B8;\n  color: #0F172A;\n  transform: scale(1.05);\n}\n\n.bug-report-button:focus-visible {\n  outline: none;\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);\n}\n\n.bug-report-button:active {\n  transform: scale(0.98);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
